  import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

import {LoanService} from '../../shared-component/service/loan/loan.service';

import {ROUTES} from './menu-items';

@Component({
  selector: 'ap-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {

  showMenu: string = '';
  showSubMenu: string = '';
  public sidebarnavItems: any[];
  public loanList: any[];

  @Output() closeSideBar = new EventEmitter();

  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }

  constructor(
    private router: Router,
    private loanService: LoanService
  ) {
    this.getLoans();
  }

  ngOnInit() {
    this.sidebarnavItems = ROUTES.map(sidebarnavItem => sidebarnavItem);
  }

  getLoans() {
    let params: any = {
      limit: 100,
      page: 1
    };

    this.loanService.loanStatus(params).subscribe((res: any) => {
      this.loanList = res.data.reduce((acc, data) => {
        if (data.LoanEmis.find((LoanEmis) => (LoanEmis.status === 'Not Paid')
          || (LoanEmis.status === 'Partially Paid' && new Date() >= new Date(`${LoanEmis.dueDate}`)))) {
          acc.push(data);
        }
        return acc;
      }, []);
    });
  }

  navigation(path) {
    this.showMenu = '0';
    this.router.navigateByUrl(path).then();
    if (window.innerWidth <= 767) {
      this.closeSideBar.emit();
    }
  }

  payNow() {
    if (this.loanList.length > 1)
      this.router.navigateByUrl('/loans').then();
    else if (this.loanList.length === 1)
      this.router.navigateByUrl(`/loans/payment/${this.loanList[0].id}`).then();
  }

}
